import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ResetPassword() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success(t("reset.done"));
      navigate("/login", { replace: true });
    } catch (err) { toast.error(apiError(err, t)); } finally { setLoading(false); }
  };

  return (
    <div className="relative mx-auto flex min-h-screen max-w-md flex-col bg-[#F8FAF8]">
      <div className="flex justify-end p-4"><LanguageSwitcher /></div>
      <div className="flex flex-1 flex-col justify-center px-6 pb-16">
        <div className="rounded-3xl border border-[#E2EAE5] bg-white p-6 shadow-sm">
          <h1 className="mb-4 font-display text-2xl font-extrabold text-[#1A2E26]">{t("reset.title")}</h1>
          <form onSubmit={submit} className="space-y-3">
            <div className="relative">
              <Lock size={18} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#7A9488]" />
              <Input data-testid="reset-password-input" type="password" required minLength={6} value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder={t("reset.newPassword")} className="h-12 rounded-xl pl-10" />
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading || !token}
              className="h-12 w-full rounded-xl bg-[#2D5A4C] text-base font-semibold hover:bg-[#214439]">
              {loading ? "…" : t("reset.resetCta")}
            </Button>
            <button type="button" data-testid="reset-back" onClick={() => navigate("/login")}
              className="w-full text-center text-xs font-semibold text-[#2D5A4C] hover:underline">{t("reset.back")}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
